import { render, staticRenderFns } from "./AutoDeductionSettings.vue?vue&type=template&id=4fdb80cb&"
import script from "./AutoDeductionSettings.vue?vue&type=script&lang=js&"
export * from "./AutoDeductionSettings.vue?vue&type=script&lang=js&"
import style0 from "./AutoDeductionSettings.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports